/**
 * @file ArrivedTaskModal.jsx
 * @location src/components/mypage/ArrivedTaskModal.jsx
 * @role 「업무 도착」 도착 업무 상세 보기 — 읽기 전용(여는 것만으론 읽음 안 됨).
 *   상세 본문은 TaskDetailHeader(공용) 재사용. 모달 안 「확인하고 시작」 = ACK_TASK(읽음) → 표로 이동.
 *   ProgModal과 달리 여는 즉시 자동 읽음하지 않는 점이 핵심(확인 흐름 보존).
 */
import { useApp } from '../../store/AppContext';
import { Overlay } from '../modals/Overlay';
import { TaskDetailHeader } from '../modals/progmodal/TaskDetailHeader';
import { Icon } from '../ui/Icon';

/**
 * @param {object} props
 * @param {import('../../data/types.js').Task} props.task
 * @param {() => void} props.onClose
 */
export function ArrivedTaskModal({ task, onClose }) {
  const { act } = useApp();
  if (!task) return null;

  const confirm = () => { act('ACK_TASK', { id: task.id }); onClose(); };

  return (
    <Overlay onClose={onClose}>
      <div className="modal modal-prog">
        <div className="mhd">
          <span className="mtit">업무 상세</span>
          <button className="mclose" onClick={onClose} aria-label="닫기"><Icon name="x" size={16} /></button>
        </div>
        <div className="mbody">
          <TaskDetailHeader task={task} />
          <div className="mfoot mfoot-tight">
            <button type="button" className="btns" onClick={onClose}>나중에</button>
            <button type="button" className="btnp" onClick={confirm}>
              <Icon name="check" size={14} /> 확인하고 시작
            </button>
          </div>
        </div>
      </div>
    </Overlay>
  );
}
